function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { Link } from "@custom/schema";
import { DocumentIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import React from "react";
import { isTruthy } from "../../utils/isTruthy";
import { BasicHeroSection } from "../Organisms/BasicHeroSection";
import { ParagraphAccordion } from "../Organisms/PageContent/ParagraphAccordion";
import { ParagraphAnchor } from "../Organisms/PageContent/ParagraphAnchor";
import { ParagraphChart } from "../Organisms/PageContent/ParagraphChart";
import { ParagraphContactBoxes } from "../Organisms/PageContent/ParagraphContactBoxes";
import { ParagraphMainTextVideo } from "../Organisms/PageContent/ParagraphMainTextVideo";
import { ParagraphMetrics } from "../Organisms/PageContent/ParagraphMetrics";
import { ParagraphTabTeaser } from "../Organisms/PageContent/ParagraphTabTeaser";
import { ParagraphText } from "../Organisms/PageContent/ParagraphText";
import { ParagraphTwoColumnsImageTextWithBackground } from "../Organisms/PageContent/ParagraphTwoColumnsImageTextWithBackground";
import { ParagraphTwoColumnsText } from "../Organisms/PageContent/ParagraphTwoColumnsText";
import { ParagraphVideos } from "../Organisms/PageContent/ParagraphVideos";
export function Page(props) {
    var _props_page_content_, _props_page_content, _props_page_content1, _props_page, _props_page_files, _props_page_files1;
    var _props_page_files_filter_length;
    return /*#__PURE__*/ React.createElement("div", {
        className: "mb-16 md:mb-20"
    }, /*#__PURE__*/ React.createElement(BasicHeroSection, {
        title: props.page.title,
        imageFull: props.page.imageFull,
        imagePortrait: props.page.imagePortrait,
        lead: props.page.lead,
        breadcrumbs: props.page.breadcrumbs
    }), /*#__PURE__*/ React.createElement("div", {
        className: clsx({
            "py-[1.5rem] md:py-[2.5rem]": ((_props_page_content = props.page.content) === null || _props_page_content === void 0 ? void 0 : (_props_page_content_ = _props_page_content[0]) === null || _props_page_content_ === void 0 ? void 0 : _props_page_content_.__typename) === "ParagraphAccordion"
        })
    }, (_props_page = props.page) === null || _props_page === void 0 ? void 0 : (_props_page_content1 = _props_page.content) === null || _props_page_content1 === void 0 ? void 0 : _props_page_content1.filter(isTruthy).map(function(block, index) {
        switch(block.__typename){
            case "ParagraphAccordion":
                return /*#__PURE__*/ React.createElement(ParagraphAccordion, _object_spread_props(_object_spread({}, block), {
                    key: index
                }));
            case "ParagraphText":
                return /*#__PURE__*/ React.createElement(ParagraphText, _object_spread_props(_object_spread({}, block), {
                    key: index
                }));
            case "ParagraphChart":
                return /*#__PURE__*/ React.createElement(ParagraphChart, _object_spread_props(_object_spread({}, block), {
                    key: index
                }));
            case "ParagraphTwoColumnsImageText":
                return /*#__PURE__*/ React.createElement(ParagraphTwoColumnsImageTextWithBackground, _object_spread_props(_object_spread({}, block), {
                    key: index
                }));
            case "ParagraphVideos":
                return /*#__PURE__*/ React.createElement(ParagraphVideos, _object_spread_props(_object_spread({}, block), {
                    key: index
                }));
            case "ParagraphTwoColumnsText":
                return /*#__PURE__*/ React.createElement(ParagraphTwoColumnsText, _object_spread_props(_object_spread({}, block), {
                    key: index
                }));
            case "ParagraphMainTextVideo":
                return /*#__PURE__*/ React.createElement(ParagraphMainTextVideo, _object_spread_props(_object_spread({}, block), {
                    key: index
                }));
            case "ParagraphAnchor":
                return /*#__PURE__*/ React.createElement(ParagraphAnchor, _object_spread_props(_object_spread({}, block), {
                    key: index
                }));
            case "ParagraphTabTeaser":
                return /*#__PURE__*/ React.createElement(ParagraphTabTeaser, _object_spread_props(_object_spread({}, block), {
                    key: index
                }));
            case "ParagraphContactBoxes":
                return /*#__PURE__*/ React.createElement(ParagraphContactBoxes, _object_spread_props(_object_spread({}, block), {
                    key: index
                }));
            case "ParagraphMetrics":
                return /*#__PURE__*/ React.createElement(ParagraphMetrics, _object_spread_props(_object_spread({}, block), {
                    key: index
                }));
        }
    })), ((_props_page_files_filter_length = (_props_page_files = props.page.files) === null || _props_page_files === void 0 ? void 0 : _props_page_files.filter(isTruthy).length) !== null && _props_page_files_filter_length !== void 0 ? _props_page_files_filter_length : 0) > 0 && /*#__PURE__*/ React.createElement("div", {
        className: "paragraph-container"
    }, (_props_page_files1 = props.page.files) === null || _props_page_files1 === void 0 ? void 0 : _props_page_files1.filter(isTruthy).map(function(file, index) {
        return /*#__PURE__*/ React.createElement("div", {
            className: "container-page mb-[0.75rem] md:mb-[1.5rem] last:mb-0",
            key: index
        }, /*#__PURE__*/ React.createElement("div", {
            className: "container-content"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "container-text items-center flex flex-row gap-1"
        }, /*#__PURE__*/ React.createElement(DocumentIcon, {
            className: "w-5 h-5 text-green-800 inline-block"
        }), /*#__PURE__*/ React.createElement(Link, {
            href: file.url
        }, file.name))));
    })));
}
